import { AxiosError } from "axios";
import http from "infra/http";
import { useMutation } from "react-query";

export function useDeleteVeiculo() {
  return useMutation<{success: boolean}, AxiosError, string>(
    async (id: string) => {
      const {data} = await http.delete<{success: boolean}>(`/v1/veiculo/${id}`)

      return data;
    }
  );
}